import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';

const ContactForm = ({ theme }) => {
    const [templateParams, setTemplateParams] = useState({
        from_name: '',
        from_email: '',
        from_number: '',
        message: ''
    });

    const onInputChange = e => {
        setTemplateParams({ ...templateParams, [e.target.name]: e.target.value })
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        emailjs.send('service_g7vb4is', 'template_kspafh9', templateParams, 'JuykCqLZvQc2UCX4A')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
            }, (err) => {
                console.log('FAILED...', err);
            });
        swal({
            title: "Sent Successfully!",
            text: "Thank you for reaching out to me through the contact form. 📝 Your message has been sent successfully. 🎉 I'll make sure to review your inquiry thoroughly and get back to you as soon as possible.",
            icon: "success",
        });
        setTemplateParams({
            from_name: '',
            from_email: '',
            from_number: '',
            message: ''
        })
    }

    return (
        <div style={{ marginTop: "120px" }}>
            <h1 style={{ marginTop: "10px", textAlign: "center" }}>Send me your message</h1>
            {/* <hr style={{marginBottom:"20px",marginLeft:"10px",marginRight:"10px"}}/> */}
            <form onSubmit={e => onSubmit(e)} style={theme.name === "light" ? styles.form : darkStyles.form}>
                <label style={theme.name === "light" ? styles.label : darkStyles.label}>
                    Name:
                    <input
                        type="text"
                        onChange={e => onInputChange(e)} 
                        value={templateParams.from_name} 
                        name="from_name"
                        style={theme.name === "light" ? styles.input : darkStyles.input}
                    />
                </label>
                <br />
                <label style={theme.name === "light" ? styles.label : darkStyles.label}>
                    Email:
                    <input
                        type="email"
                        onChange={e => onInputChange(e)} 
                        value={templateParams.from_email} 
                        name="from_email"
                        style={theme.name === "light" ? styles.input : darkStyles.input}
                    />
                </label>
                <br />
                <label style={theme.name === "light" ? styles.label : darkStyles.label}>
                    Phone:
                    <input
                        type="tel"
                        onChange={e => onInputChange(e)} 
                        value={templateParams.from_number} 
                        name="from_number"
                        style={theme.name === "light" ? styles.input : darkStyles.input}
                    />
                </label>
                <br />
                <label style={theme.name === "light" ? styles.label : darkStyles.label}>
                    Message:
                    <textarea
                        onChange={e => onInputChange(e)} 
                        value={templateParams.message} 
                        name="message"
                        style={theme.name === "light" ? styles.textarea : darkStyles.textarea}
                    />
                </label>
                <br />
                <button type="submit" style={styles.button}>
                    Submit
                </button>
            </form>
        </div>
    );
};

const styles = {
    heading: {
        align: 'center',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        maxWidth: '500px',
        margin: '0 auto',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        padding: '30px',
        borderRadius: '20px',
        backgroundColor: '#fff',
    },
    label: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '5px',
        fontSize: '1rem',

    },
    input: {
        padding: '10px',
        fontSize: '1rem',
        border: '1px solid #ddd',
        borderRadius: '5px',
        outline: 'none',
    },
    textarea: {
        padding: '10px',
        fontSize: '1rem',
        border: '1px solid #ddd',
        borderRadius: '5px',
        outline: 'none',
        resize: 'vertical',
    },
    button: {
        padding: '10px 20px',
        fontSize: '1rem',
        backgroundColor: '#007BFF',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease',
    },
    h1: {
        textAlign: 'center', // Add this property to center the text in <h1>
        fontSize: '2rem',
        marginBottom: '20px',
        marginTop: '80px',
    },
};

const darkStyles = {
    form: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '500px',
        margin: '0 auto',
        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)', // Adjust the shadow color for dark mode
        padding: '30px',
        borderRadius: '20px',
        backgroundColor: '#333', // Change the background color to a darker shade
    },
    label: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '5px',
        fontSize: '1rem',

        color: '#ddd', // Adjust the text color for labels in dark mode
    },
    input: {
        padding: '10px',
        fontSize: '1rem',
        border: '1px solid #555', // Adjust the border color for input fields in dark mode
        borderRadius: '5px',
        outline: 'none',
        backgroundColor: '#444', // Change the background color of input fields
        color: '#ddd', // Adjust the text color for input fields in dark mode
    },
    textarea: {
        padding: '10px',
        fontSize: '1rem',
        border: '1px solid #555', // Adjust the border color for textarea in dark mode
        borderRadius: '5px',
        outline: 'none',
        resize: 'vertical',
        backgroundColor: '#444', // Change the background color of textarea
        color: '#ddd', // Adjust the text color for textarea in dark mode
    },
    button: {
        padding: '10px 20px',
        fontSize: '1rem',
        backgroundColor: '#007BFF', // You can choose a different accent color for buttons in dark mode
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease',
    },
};


export default ContactForm;
